<template>
  <div class="box8-page">
    <pageTitle 
      title="该全则全  账号运营需要的知识全部送" 
      tit="只花一次钱，解决你IP带货账号所有问题！ (前200份免费送，送完为止)"
      titleColor="#000"
      titColor="#333"
    />
    <div class="page-content common-animation">
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item, index) in list" :key="index + 'swiper'">
          <div class="slide-cont" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave">
            <h2>{{ item.name }}</h2>
            <div class="num">{{ '0' + (index + 1) }}</div>
            <div class="line"></div>
            <div class="cont-title">
              <div class="img-mask">
                <img src="../../../assets/topic-page/newMedia2/box7/icon-02.png" alt="">
              </div>
              <span>学后收获</span>
            </div>
            <div class="info">{{ item.info1 }}</div>
            <div class="cont-title">
              <div class="img-mask">
                <img src="../../../assets/topic-page/newMedia2/box7/icon-03.png" alt="">
              </div>
              <span>可解决的现实问题</span>
            </div>
            <ul>
              <li v-for="(v1, i1) in item.info2" :key=" i1 + 'info2-' + index">{{ v1 }}</li>
            </ul>
          </div>
        </swiper-slide>
      </swiper>

      <!-- 滚动条 -->
      <div class="nav-scorll">
        <div
          class="scorll-block"
          :style="{ left: initialWidth + 'px' }"
        ></div>
      </div>
    </div>
    <div class="btn" @click="childMethod">立抢活动名额</div>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  import pageTitle from "../../../components/common/pageTitle.vue";
  export default {
    components:{
      pageTitle,
      swiper,
      swiperSlide
    },
    name: '',
    data() {
      let _this = this
      return {
        initialWidth: 0,
        swiperOption: {
          // loop: true, //是否循环
          autoplay: {
            delay: 3000, // 自动播放的时长
            stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
            disableOnInteraction: false
          },
          slidesPerView: "auto",
          spaceBetween: 30, //  每张图片之间的间隔
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          on:{
            slideChangeTransitionStart(){
              _this.initialWidth = this.activeIndex * 40
            }
          }
        },
        list:[
          {
            name: '如何选品',
            info1: '掌握如何选品。',
            info2: [
              '掌握通过什么工具进行选品，以及怎么选品、选品中需要注意的问题。'
            ]
          },
          {
            name: '拍摄',
            info1: '掌握拍摄基本技能。',
            info2: [
              '解决学员拍摄的基本技能提升，包括景别、构图、运镜、光线技能；',
              '掌握具体的拍摄方法：三段摇拍摄、推进式拍摄、剧情拍摄、过肩拍摄技巧等。'
            ]
          },
          {
            name: '剪辑',
            info1: '掌握剪映剪辑技巧。',
            info2: [
              '解决学员不会用剪辑软件剪辑包装作品的问题。通过学习剪映各种效果制作技能，可获得剪辑、制作作品能力。'
            ]
          },
          {
            name: '前3秒设计50招',
            info1: '获得更多吸睛开头设计的方法。',
            info2: [
              '解决学员视频开头不吸引人的难题，通过50招前3秒的设计方法，可快速提升视频5秒完播数据。'
            ]
          },
          {
            name: '直播全流程',
            info1: '掌握直播运营必备技能，包括开场直播话术、开价话术、转款话术、爆款直播间拆解方法、直播间数据分析与复盘能力。',
            info2: [
              '解决学员不知道如何做直播内容撰写的问题；',
              '解决学员不会做直播数据分析复盘问题。'
            ]
          },
          {
            name: '本地同城流量最新玩法',
            info1: '掌握本地同城账号的运营方法，包括入驻、团单设置及核销、团单视频拍摄公式、如何获取同城搜索流量、本地地推使用方法等。',
            info2: [
              '解决学员不会做本地同城账号运营的问题，解决从入驻到上架团单，到生产适合团单销售，到视频/推广，到运营等各类问题。'
            ]
          },
          {
            name: '抖店运营',
            info1: '掌握抖店必备的运营技能，包括小店入驻、产品上架、商品卡搜索流量布局、数据分析等。',
            info2: [
              '解决学生不会做抖店商品卡流量获取问题，以及抖店整体运营数据分析的问题；',
              '学员通过课程学习掌握抖店运营的各项能力。'
            ]
          },
        ]
      }
    },
    methods: {
      on_bot_enter() {
        this.$refs.mySwiper.$el.swiper.autoplay.stop();
      },
      on_bot_leave() {
        this.$refs.mySwiper.$el.swiper.autoplay.start();
      },
      childMethod() {
        this.$parent.itcastClick();
      }
    }
  }
</script>

<style lang="scss" scoped>
.box8-page{
  height: 860px;
  background-image: url(../../../assets/topic-page/newMedia2/box8/box8-bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 80px; 
  box-sizing: border-box;
  .btn{
      width: 207px;
      height: 56px;
      font-size: 20px;
      color: #fff;
      text-align: center;
      line-height: 56px;
      border-radius: 28px;
      font-weight: bold;
      box-sizing: border-box;
      box-shadow: 0 8px 7px #e2b8db;
      background: url("../../../assets/topic-page/newMedia2/btnbg1.png") no-repeat;
      cursor: pointer;
      margin: 40px auto 0;
      padding-right: 20px;
      &:hover{
        box-shadow: none;
      }
    }
  .page-content{
    width: 1200px;
    margin: 49px auto 0;
    position: relative;
    .swiper-button-prev,
    .swiper-button-next{
      width: 48px;
      height: 48px;
      background-color: #ffffff;
      box-shadow: 0px 10px 20px 0px 
        #f6edf0;
      cursor: pointer;
      border-radius: 50%;
      background-image: url(../../../assets/topic-page/newMedia2/box8/icon-left.png);
      background-repeat: no-repeat;
      background-size: 11px 20px;
      background-position: center;
      &::after{
        display: none;
      }
    }
    .swiper-button-prev{
      position: absolute;
      left: -77px;
    }
    .swiper-button-next{
      right: -77px;
      transform: rotate(180deg);
    }
    .swiper-container{
      .swiper-slide{
        width: 380px;
        height: 416px;
        background-color: #ffffff;
        border-radius: 20px;
        .slide-cont{
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding: 50px 30px;
          position: relative;
          h2{
            font-family: PingFang-SC-Bold;
            font-size: 26px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            letter-spacing: 1px;
            color: #ff3377;
          }
          .num{
            position: absolute;
            top: 31px;
            right: 29px;
            font-family: PingFang-SC-Heavy;
            font-size: 72px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 48px;
            letter-spacing: 0px;
            color: #ff4180;
            opacity: 0.08;
          }
          .line{
            width: 300px;
            height: 2px;
            background-image: linear-gradient(90deg, 
              #ffb2cc 0%, 
              #ffffff 100%);
              margin-top: 30px;
          }
          .cont-title{
            margin-top: 30px;
            display: flex;
            align-items: center;
            .img-mask{
              width: 18px;
              margin-right: 6px;
              img{
                height: 18px;
              }
            }
            span{
              font-family: PingFang-SC-Bold;
              font-size: 18px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 18px;
              letter-spacing: 1px;
              color: #191c47;
            }
          }
          .info{
            margin-top: 13px;
            font-family: PingFang-SC-Regular;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #253326;
          }
          ul{
            margin-top: 13px;
            li{
              font-family: PingFang-SC-Regular;
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 24px;
              letter-spacing: 0px;
              color: #253326;
            }
          }
        }
      }
    }


    .nav-scorll {
      position: relative;
      margin: 50px auto 0;
      width: 280px;
      height: 8px;
      background-color: #ffccdd;
	    border-radius: 4px;
      .scorll-block {
        position: absolute;
        left: 0px;
        width: 120px;
        height: 8px;
        background-color: #ff6699;
        border-radius: 4px;
        transition: 0.5s ease all;
      }
    }
  }
}
</style>